import React, { useState, createContext } from "react";

export const UserContext = createContext();

export const UserConsumer = ({ children }) => {
  const [currentUser, setCurrentUser] = useState(false);

  return (
    <UserContext.Provider value={{ currentUser, setCurrentUser }}>
      {children}
    </UserContext.Provider>
  );
};
